import styled from 'styled-components';
import { transparentize } from 'polished';

/**
 * Visual shell so SunEditor roughly matches the previous TinyMCE chrome
 * used in Email Report and other admin modals.
 */
export const EditorShell = styled.div`
  display: block;
  width: 100%;
  border: 1px solid ${transparentize(0.75, '#737384')};
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.08);
  position: relative;
  z-index: 0;
  /* NOTE: overflow stays visible on purpose — SunEditor renders its
   * link/image/table dialogs, dropdowns and colour controllers as
   * absolutely-positioned layers inside the container. overflow:hidden
   * (previously used for corner rounding) clipped them, especially in
   * short (200px) editors. Corners are rounded per-region instead. */
  overflow: visible;
  /* SunEditor inherits text-align from ancestors (modals/boxes often
   * centre). Reset it here so content AND the placeholder watermark
   * always start left-aligned; user alignment via the toolbar still
   * wins because it sets inline styles. */
  text-align: left;

  & .sun-editor {
    border: none !important;
    border-radius: 0 !important;
    font-family: Helvetica, Arial, sans-serif;
    position: relative;
    z-index: 0;
    text-align: left;
  }

  & .se-toolbar {
    background: #f7f7f9 !important;
    border-bottom: 1px solid ${transparentize(0.8, '#737384')} !important;
    outline: none !important;
    padding: 4px 6px !important;
    border-radius: 3px 3px 0 0 !important;
    z-index: 1 !important;
  }

  & .se-btn-tray {
    padding: 0 !important;
  }

  & .se-btn {
    color: #4b5563 !important;
    border-radius: 3px !important;
  }

  & .se-btn:hover,
  & .se-btn-active {
    background: ${transparentize(0.88, '#825efb')} !important;
    color: #5b3fd4 !important;
  }

  & .se-wrapper {
    background: #fff;
    text-align: left;
  }

  & .se-wrapper-inner {
    min-height: 120px;
    text-align: left;
  }

  & .se-wrapper-wysiwyg,
  & .se-wrapper .se-wrapper-inner {
    font-family: Helvetica, Arial, sans-serif !important;
    font-size: 14px !important;
    line-height: 1.5;
    color: #1f2937;
    padding: 12px 14px !important;
    text-align: left;
  }

  /* Placeholder ("watermark") has no text-align of its own upstream,
   * so it inherits centring too — pin it left explicitly. */
  & .se-placeholder {
    text-align: left !important;
    /* Keep it aligned with the editable padding above */
    padding-left: 14px !important;
  }

  & .se-resizing-bar {
    background: #f7f7f9 !important;
    border-top: 1px solid ${transparentize(0.85, '#737384')} !important;
    border-radius: 0 0 3px 3px !important;
    color: #6b7280 !important;
  }

  & .se-resizing-bar .se-resizing-bar-icon,
  & .se-resizing-bar .se-navigation {
    color: #6b7280 !important;
  }

  /* Hide SunEditor brand mark for a cleaner Tiny-like footer */
  & .se-resizing-bar .se-resizing-bar-icon {
    opacity: 0.35;
  }
`;
